import { useState } from "react";
import { useForm } from "react-hook-form";
import { RefreshCcw } from "lucide-react";

import CenteredHeading from "../../../../components/UI/headingsUI/CenteredHeading";
import PersonalInfo from "./PersonalInfo";
import BankInfo from "./BankInfo";
import GrayButton from "../../../../components/UI/buttonUI/GrayButton";
import UserViewDetailsDialog from "../../dialogs/UserViewDetailsDialog";
import { areObjectsEqual } from "../../../../functions/areObjectsEqual";
import PrimaryButton from "../../../../components/UI/buttonUI/PrimaryButton";

const UpdateUserForm = ({
  userSetup,
  userData,
  sendData,
  loading,
  successResponse,
}) => {
  const [formError, setFormError] = useState(false);

  const userExistingData = {
    fullName: userData.fullName || "",
    salary: userData.salary || "",
    genderId: userData.gender?.id || "",
    dob: userData.dob || "",
    mobile: userData.mobileNumber || "",
    altPhoneNumber: userData.altPhoneNumber || "",
    dateOfJoining: userData.dateOfJoining,
    aadharCardNumber: userData.aadharCardNumber,
    panCardNumber: userData.panCardNumber,
    bikeRegNumber: userData.bikeRegNumber || "",
    bankNameId: userData.bankName?.id || "",
    accountNumber: userData.accountNumber || "",
    ifsc: userData.ifsc || "",
    branchName: userData.bankBranch || "",
  };

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors },
    reset,
  } = useForm({ defaultValues: userExistingData });

  const { bankNameId } = watch();

  // send data into form data

  const onSubmit = (data) => {
    if (areObjectsEqual(data, userExistingData)) {
      setFormError(true);
    } else {
      setFormError(false);
      sendData(data, () => {}, userExistingData);
    }
  };

  // handle clear form
  const handleClearForm = () => {
    setFormError(false);
    reset(userExistingData);
  };

  return (
    <div className="form-container">
      <CenteredHeading title="Update User" />
      <form onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}>
        <div className="flex flex-wrap">
          <PersonalInfo
            userSetup={userSetup}
            register={register}
            errors={errors}
            setValue={setValue}
            control={control}
            watch={watch}
          />
          <BankInfo
            userSetup={userSetup}
            register={register}
            errors={errors}
            setValue={setValue}
            control={control}
            bankNameId={bankNameId}
          />
        </div>
        {formError && (
          <p className="userFormErr">At least one field must be edited.</p>
        )}
        <div className="flex-center-align pt-8">
          <p className="addWrap">
            <PrimaryButton
              btnText={!loading ? "Update User" : "Updating..."}
              loading={loading}
              Icon={RefreshCcw}
              size={18}
            />
          </p>
          <p className="grayWrap">
            <GrayButton
              btnText="Clear"
              width="w-40"
              onClick={handleClearForm}
            />
          </p>
        </div>
      </form>
      {successResponse && (
        <UserViewDetailsDialog
          viewDetails={successResponse}
          successMsg="User Successfully Updated!"
        />
      )}
    </div>
  );
};
export default UpdateUserForm;
